import { PopupRequest } from '@azure/msal-browser';

/** Input required to create a fresh Microsoft Entra step-up authentication request. */
export interface EntraStepUpRequestOptions {
  authority: string;
  loginHint: string;
  authenticationContext?: string;
}

/**
 * Creates the shared MSAL request used by Global Console and approval-required agent actions.
 * The AMR claim must request the concrete `mfa` value; an essential claim without a value is
 * serialized by Entra as an empty AMR request and rejected with AADSTS901001.
 */
export function buildEntraStepUpRequest(options: EntraStepUpRequestOptions): PopupRequest {
  const idTokenClaims: any = {
    amr: { essential: true, values: ['mfa'] },
    auth_time: { essential: true }
  };
  const requestedClaims: any = { id_token: idTokenClaims };

  if (options.authenticationContext) {
    idTokenClaims.acrs = { essential: true, value: options.authenticationContext };
    requestedClaims.access_token = {
      acrs: { essential: true, value: options.authenticationContext }
    };
  }

  return {
    scopes: ['user.read'],
    authority: options.authority,
    loginHint: options.loginHint,
    prompt: 'login',
    extraQueryParameters: { max_age: '0' },
    claims: JSON.stringify(requestedClaims)
  };
}
